import './App.css';
import './styles/header.css';
import './styles/footer.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout.js';
import HomePage from './components/homepage';
import SheetViewer from './components/sheetviewer.js';
import { WorkbookProvider } from './contexts/WorkbookContext';



function App() {
  return (
    <WorkbookProvider>
      <Layout>
        <Routes>
          {/* <Route path='' element={getToken() ?  <HomePage/>: <LoginPage/> }/> */}
          <Route path= '/' element={<HomePage/>}/>
          <Route path= '/home' element={<HomePage/>}/>
          <Route path="/view/:workbookName/:sheetName" element={<SheetViewer />} />
        </Routes>
      </Layout>
    </WorkbookProvider>
  );
}

export default App;
